"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDescriptionV2 = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const rich_content_1 = require("../rich-content");
const styles_1 = require("./styles");
const ProductDescriptionV2 = (props) => {
    const { backgroundColor, contentJustify, textAlign, title, productDescription, seeMoreCopy, seeLessCopy, maxHeight, fontSize } = props;
    return productDescription !== undefined ? (react_1.default.createElement(styles_1.StyledDescriptionContainer, { "background-color": backgroundColor, justify: contentJustify, "text-align": textAlign, "data-cy": 'product-description' },
        react_1.default.createElement(__1.ThemedHeading, { bold: true, headingLevel: 2, font: "large" }, title),
        react_1.default.createElement("br", null),
        react_1.default.createElement(__1.SeeMore, { seeMoreCopy: seeMoreCopy, seeLessCopy: seeLessCopy, maxHeight: maxHeight },
            react_1.default.createElement(rich_content_1.RichContentElement, { fontSize: fontSize }, productDescription)))) : (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.ProductDescriptionV2 = ProductDescriptionV2;
__exportStar(require("./types"), exports);
